import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Avatar } from "@/components/Avatar";
import { NotificationBell } from "@/components/NotificationBell";
import { ContractorMenu } from "@/components/ContractorMenu";
import { SignOut } from "@phosphor-icons/react";

export function Layout({ children, title }) {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            {user?.role === "employee" && <ContractorMenu />}
            <div className="w-11 h-11 bg-white border border-border flex items-center justify-center">
              <img src="/logo.png" alt="Caring Hands" className="w-9 h-9 object-contain" />
            </div>
            <div>
              <div className="font-display font-bold text-lg leading-none tracking-tighter">Caring Hands</div>
              <div className="label-caps text-[0.6rem] mt-0.5">{title}</div>
            </div>
          </div>
          <div className="flex items-center gap-4">
            {user?.role === "admin" && <NotificationBell />}
            <div className="text-right hidden sm:block">
              <div className="text-sm font-medium leading-none" data-testid="nav-user-name">{user?.name}</div>
              <div className="label-caps text-[0.6rem] mt-1">{user?.role}</div>
            </div>
            <Link to="/profile" className="flex items-center gap-2" data-testid="profile-nav-button">
              <Avatar userId={user?.id} hasPhoto={user?.has_photo} updatedAt={user?.avatar_updated} name={user?.name} size={36} />
              <span className="sr-only">Profile</span>
            </Link>
            <Button
              variant="outline"
              size="sm"
              className="rounded-none"
              onClick={logout}
              data-testid="logout-button"
            >
              <SignOut size={16} className="mr-1.5" /> Sign out
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">{children}</main>
    </div>
  );
}
